export const ROUTES = {
  NOTIFICATIONS: '/center/notifications',
  SETTINGS: '/center/settings',
};
